import React from 'react';
import { Modal, Form, Input, Table as AntTable, Button, Select } from 'antd';

const statusOptions = [
  { value: 'pending', label: 'Pending' },
  { value: 'completed', label: 'Completed' },
  { value: 'failed', label: 'Failed' },
  { value: 'cancelled', label: 'Cancelled' },
];

const UpdateOrderModal = ({ open, loading, order, onClose, onUpdate }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    title="Update Order"
    width={800}
    destroyOnClose
    centered
    maskClosable
    loading={loading}
  >
    {order && (
      <Form
        layout="vertical"
        initialValues={{
          status: order.status,
          note: order.note,
        }}
        onFinish={onUpdate}
      >
        <div style={{ display: 'flex', gap: 16 }}>
          <Form.Item label="Order Code" style={{ flex: 1 }}>
            <Input value={order.shortCode} disabled />
          </Form.Item>
          <Form.Item label="Total Amount in VND" style={{ flex: 1 }}>
            <Input value={order.totalAmount?.toLocaleString()} disabled />
          </Form.Item>
          {order.status === 'pending' ? (
            <Form.Item label="Status" name="status" style={{ flex: 1 }} rules={[{ required: true }] }>
              <Select options={statusOptions} />
            </Form.Item>
          ) : (
            <Form.Item label="Status" style={{ flex: 1 }}>
              <Input value={order.status.charAt(0).toUpperCase() + order.status.slice(1)} disabled />
            </Form.Item>
          )}
        </div>
        <Form.Item label="Note" name="note" rules={[{ max: 500, message: 'Note cannot exceed 500 characters.' }]}>
          <Input />
        </Form.Item>
        <div style={{ display: 'flex', gap: 16 }}>
          <Form.Item label="Learner Name" style={{ flex: 1 }}>
            <Input value={order.userId?.firstName + ' ' + order.userId?.lastName} disabled />
          </Form.Item>
          <Form.Item label="Learner email" style={{ flex: 1 }}>
            <Input value={order.userId?.email} disabled />
          </Form.Item>
        </div>
        <div style={{ display: 'flex', gap: 16 }}>
          <Form.Item label="Purchased Date" style={{ flex: 1 }}>
            <Input value={order.purchaseDate ? new Date(order.purchaseDate).toLocaleDateString('vi-VN') : ''} disabled />
          </Form.Item>
          <Form.Item label="Last Update" style={{ flex: 1 }}>
            <Input value={order.updatedAt ? new Date(order.updatedAt).toLocaleDateString('vi-VN') : ''} disabled />
          </Form.Item>
        </div>
        <div style={{ marginTop: 16 }}>
          <b>Course List</b>
          <AntTable
            dataSource={order.courseIds || []}
            rowKey={(r, idx) => r._id || idx}
            pagination={false}
            style={{ marginTop: 8, minWidth: 750 }}
            bordered
            size="small"
            columns={[
              {
                title: 'No',
                dataIndex: 'no',
                width: 50,
                align: 'center',
                render: (t, r, idx) => idx + 1,
              },
              {
                title: 'Category',
                dataIndex: 'category',
                width: 180,
                render: (t, r) => r.category?.name || '',
              },
              {
                title: 'Course Name',
                dataIndex: 'name',
                width: 340,
                render: (t, r) => <div style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{r.name}</div>,
              },
              {
                title: 'Price',
                dataIndex: 'price',
                width: 100,
                render: (t, r) => '$' + (r.price?.toLocaleString() || ''),
              },
            ]}
            summary={pageData => {
              const total = (order.courseIds || []).reduce((sum, c) => sum + (c.price || 0), 0);
              return (
                <AntTable.Summary.Row>
                  <AntTable.Summary.Cell index={0} colSpan={3} align="right"><b>Total:</b></AntTable.Summary.Cell>
                  <AntTable.Summary.Cell index={3}><b>${total.toLocaleString()}</b></AntTable.Summary.Cell>
                </AntTable.Summary.Row>
              );
            }}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <b>Total Amount: {order.totalAmount?.toLocaleString()}VNĐ</b>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading}>Update</Button>
        </div>
      </Form>
    )}
  </Modal>
);

export default UpdateOrderModal; 